import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next) // Passes i18n instance to react-i18next.
  .init({
    resources: {
      en: {
        translation: {
          // Your translation keys and values.
        },
      },
      // Additional languages...
    },
    lng: 'en', // Default language.
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // Not needed for React.
    },
    react: {
      useSuspense: true,
    }
  });

export default i18n;
